import {
  DRAFT_POLL_MS,
  MODERATION_ERROR_RETRY_MS,
  MODERATION_POLL_MS,
} from '../useCourseModeration'
import type { ModerationState, ReviewStatus } from '../types'

/** Живой (курс или статья виден ученикам): черновик могли завести вне студии. */
export const isLiveModeration = (state: ModerationState | undefined): boolean =>
  state !== undefined && state.visibility !== 'unpublished'

/** Интервал опроса: пока `pending` — раз в `MODERATION_POLL_MS`; упала первая загрузка —
 *  повтор раз в `MODERATION_ERROR_RETRY_MS`; живой вне проверки — раз в `DRAFT_POLL_MS`
 *  (черновик, заведённый через MCP или второй вкладкой); иначе остановка (`0`, не `skip`). */
export const pollingFor = (
  status: ReviewStatus | undefined,
  firstLoadFailed: boolean,
  isLive: boolean,
): number => {
  if (status === 'pending') return MODERATION_POLL_MS
  if (firstLoadFailed) return MODERATION_ERROR_RETRY_MS
  return isLive ? DRAFT_POLL_MS : 0
}
